import { BookOpen, Map, Image, Camera } from 'lucide-react';

const DataIcon = ({ type }) => {
    const iconStyle = "w-7 h-7 mr-2"; // Common style for icons

    switch (type.toLowerCase()) {
        case 'maps':
            return <Map className={iconStyle} />;
        case 'books':
            return <BookOpen className={iconStyle} />;
        case 'original prints':
            return <Image className={iconStyle} />;
        case 'advertisements':
            return <Camera className={iconStyle} />;
        default:
            return null;
    }
}

export default DataIcon;